import React from 'react';

//Styles
import './Contact.scss';

//React-router-dom
import { Link } from 'react-router-dom';

//Font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

//SVG icons
import Dots from '../Icons/Dots';
import Square from '../Icons/Square';

function Contact() {
    return (
        <div className="contactView">
            <div className="container">
                <div className="contactForm section">
                    <h2>Contact <Dots /></h2>
                    <Square />

                    <div className="container-inner">
                        <div className="wrapper">
                            <div className="info">
                                <div className="column">
                                    <div className="heading">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                                        <h4>Address</h4>
                                    </div>
                                    <p>Plot No. 123/B, Washama Road,</p>
                                    <p>Villa Elizabeth,</p>
                                    <p>Lusaka, Zambia</p>
                                </div>

                                <div className="column">
                                    <div className="heading">
                                        <FontAwesomeIcon icon={faPhoneAlt} />
                                        <h4>Contact</h4>
                                    </div>
                                    <p>+260971564418</p>
                                    <p>+260975112233</p>
                                    <p>ravlot007@gmail.com</p>
                                </div>

                                <div className="column">
                                    <div className="heading">
                                        <FontAwesomeIcon icon={faClock} />
                                        <h4>Working hours</h4>
                                    </div>
                                   
                                </div>
                            </div>

                            {/* <div className="form">
                                <form>
                                    <input type="text" placeholder="Name" />
                                    <input type="email" placeholder="Email" />

                                    <textarea placeholder="Message"></textarea>

                                    <div className="send">
                                        <FontAwesomeIcon icon={faPaperPlane} />
                                        <Link to="">Send</Link>
                                    </div>
                                </form>
                            </div> */}
                        </div>
                    </div>
                </div>

                <div className="rental section">
                    <div className="container-inner">
                        <h2>Gold Construction Limited</h2>

                        <h1>+260971564418</h1>
                        <p>ravlot007@gmail.com</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact;